export const subscriptionPlans = [
  {
    name: "Free Account",
    price: 0,
    billed: "Per Month Billed Annually",
    description: "Free Forever. Activation Required.",
    buttonText: "Start for Free",
    isPopular: false,
  },
  {
    name: "Startup",
    price: 2449,
    billed: "One Time Payment",
    description: "A $58.99 fee required after the first 12 months",
    buttonText: "Get Started",
    isPopular: true,
  },
  {
    name: "Enterprise",
    price: 5497,
    billed: "One Time Payment",
    description: "A $58.99 fee required after the first 12 months",
    buttonText: "Get Started",
    isPopular: false,
  },
];

export const pricingData = [
  {
    section: "Cloud Storage",
    info: "All plans include 1TB of cloud storage. Additional storage can be purchased at $10 per TB per month.",
    features: [
      {
        name: "CorpCrypt",
        flatRate: "Free Account",
        dynamic: "Free Account",
        custom: "Free Account",
      },
      {
        name: "University Basic",
        flatRate: "Optional",
        dynamic: "Optional",
        custom: "Optional",
      },
      {
        name: "DIY AI website Creation",
        flatRate: "Optional",
        dynamic: "Optional",
        custom: "Optional",
      },
      {
        name: "Crypt Access",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Business Fillings",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Access To Downloads",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Business Filling",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Receive Invoices",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Orders & Services",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Business Health Usage",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Basic University",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
    ],
  },
  {
    section: "LLC/Corp Formation",
    features: [
      {
        name: "Preparing & Filing the Articles of Organization",
        flatRate: false,
        dynamic: "8 Members",
        custom: "Unlimited Members",
      },
      {
        name: "Customized Operating Agreement",
        flatRate: false,
        dynamic: true,
        custom: "Unlimited",
      },
      {
        name: "Physical Address (NOT PO BOX)",
        flatRate: false,
        dynamic: "2 Meetings To Finalize",
        custom: true,
      },
      {
        name: "Tax Consultation",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Employer Identification Number",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "EIN Confirmation Letter",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "DUNS Number",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Bylaws for Corps",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Banking Resolution",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Free Registered Agent service",
        flatRate: false,
        dynamic: "1 Year",
        custom: true,
      },
      {
        name: "IRS Form 2553",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
    ],
  },
  {
    section: "Advanced Corporate Filing",
    features: [
      {
        name: "Dedicated CPA Connection to File your taxes",
        flatRate: false,
        dynamic: true,
        custom: "Yearly",
      },
      {
        name: "Tax Consultation",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "SST Resale Certificate",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "MTC Tax Exemption",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Banking Resolution",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Banking Consultation",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "ITIN Application & Approval 'For NON-US Residents'",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Bank Account 'For NON-US Residents'",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Bylaws for Corps",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
    ],
  },
  {
    section: "Basic Business Branding & Website",
    features: [
      {
        name: "Domain Name",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Website Landing Page",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Business SEO",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Premium Business Logo",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
      {
        name: "Business Card, T-Shirt, & Accessories Design",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
      {
        name: "Business Postcards Design",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
      {
        name: "Corporate Email",
        flatRate: false,
        dynamic: false,
        custom: "2",
      },
      {
        name: "Unlimited Pages Business Website",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
    ],
  },
  {
    section: "Business Credit Building",
    info: "All plans include 1TB of cloud storage. Additional storage can be purchased at $10 per TB per month.",
    features: [
      {
        name: "Get Approved for HIGH-Limit Revolving Credit Cards in Your Business's Name with No Personal Guarantee",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
      {
        name: "Access the Largest Supply of Business Credit Sources to Get Vendor Credit, Retail Credit, Service Credit, Fleet Credit, and Business Credit Cards Linked to Your EIN",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
      {
        name: "Receive Concierge Coaching and Servicing with Your Own Business Credit Advisors Who Help You Easily Navigate the Corporate Credit Building Process",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
      {
        name: "Enjoy Our Core and Partner Programs with Affordable and Customizable Payment Plans",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
      {
        name: "Get Your Business Credit Profile Quickly Set Up and Activated with D&B, Experian, and Equifax Commercial Saving You Time and Money",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
      {
        name: "Corporate Compliance Review to Ensure Your Business Exceeds Credit Issuer and Lender Fundability™ Standards to Get Automated Approvals",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
      {
        name: "Get Business Credit and Financing through Your Own Finance Suite",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
      {
        name: "Bureau Insights™ See the same comprehensive report lenders and underwriters look at when making lending decisions",
        flatRate: false,
        dynamic: false,
        custom: true,
      },
    ],
  },
  {
    section: "Support",
    features: [
      {
        name: "Support",
        flatRate: "Basic",
        dynamic: "1 Year",
        custom: "Unlimited",
      },
      {
        name: "Priority support",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Personal Analytics Expert",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
    ],
  },
];

export const feesData = [
  {
    section: "Card Processing",
    info: "All card processing fees are based on the card type and transaction volume. The rates below are estimates and may vary based on your specific business needs.",
    features: [
      {
        name: "Processing Fee",
        flatRate: "2.75% + $0.30",
        dynamic: "Interchange + Card Brand Fees + 0.3% + $0.30",
        custom: "Contact Us",
      },
      {
        name: "Amex Processing Fee",
        flatRate: "2.75% + $0.30",
        dynamic: "Amex Fees 2.75% + $0.30",
        custom: "Contact Us",
      },
      {
        name: "Hosted Fields to Minimise PCI Scope",
        flatRate: true,
        dynamic: true,
        custom: false,
      },
      {
        name: "Machine Learning & Fraud Detection",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Level 2 and Level 3 Processing",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Subscription Billing",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
    ],
  },
  {
    section: "ACH",
    features: [
      {
        name: "Processing Fee",
        flatRate: "2.75% + $0.30",
        dynamic: "Interchange + Card Brand Fees + 0.3% + $0.30",
        custom: "Contact Us",
      },
      {
        name: "Next Day Funding Fee",
        flatRate: "2.75% + $0.30",
        dynamic: "Amex Fees 2.75% + $0.30",
        custom: "Contact Us",
      },
      {
        name: "One-Time Account Validation",
        flatRate: "$0.5",
        dynamic: "$0.5",
        custom: "Contact Us",
      },
      {
        name: "Return",
        flatRate: "$5 each",
        dynamic: "$5 each",
        custom: "2.75% + $0.30",
      },
      {
        name: "Notice of Change (NOC)",
        flatRate: "$5 per notification",
        dynamic: "$5 per notification",
        custom: true,
      },
      {
        name: "Instant Payouts",
        flatRate: "1.5%",
        dynamic: "1.5%",
        custom: "1.5%",
      },
    ],
  },
  {
    section: "Exemptions & Compliance",
    features: [
      {
        name: "Card and ACH Disputes",
        flatRate: "$15",
        dynamic: "$15",
        custom: "Contact Us",
      },
      {
        name: "Fraud Monitoring",
        flatRate: "Console & Custom ML Model Setup Fee: $1,500",
        dynamic: "Console & Custom ML Model Setup Fee: $1,500",
        custom: "Contact Us",
      },
      {
        name: "Webhook Notifications For Any Exceptions Created",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Dispute Management Tools",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Live Chargeback Expert Support",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
    ],
  },
  {
    section: "Merchant Management",
    features: [
      {
        name: "Per Merchant Payout",
        flatRate: "2.75% + $0.30",
        dynamic: "Interchange + Card Brand Fees + 0.3% + $0.30",
        custom: "Contact Us",
      },
      {
        name: "Merchant Onboarding",
        flatRate: "2.75% + $0.30",
        dynamic: "Amex Fees 2.75% + $0.30",
        custom: "Contact Us",
      },
      {
        name: "Prebuilt Merchant Onboarding Forms",
        flatRate: true,
        dynamic: false,
        custom: true,
      },
      {
        name: "Merchant Identity Verification Including KYC, KYB, and OFAC Checks",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Prebuilt Merchant Dashboards",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Customisable Payout Schedules",
        flatRate: true,
        dynamic: false,
        custom: true,
      },
    ],
  },
  {
    section: "Additional Benefits & Options",
    info: "These features are available for an additional fee or as part of a custom plan. Please contact us for more details.",
    features: [
      {
        name: "Dedicated Implementation Manager and Developer Support",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "24/7 Emergency Support and Short Response Times",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Real-Time Payment Analytics and Insights",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "No-Code Payment Links and Virtual Terminal",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Low-Code Checkout Pages",
        flatRate: true,
        dynamic: true,
        custom: true,
      },
      {
        name: "Split Transactions and Payouts",
        flatRate: false,
        dynamic: true,
        custom: true,
      },
      {
        name: "Payment Terminal Management in Your Dashboard",
        flatRate: "Contact Us",
        dynamic: "Contact Us",
        custom: "Contact Us",
      },
    ],
  },
];

export const faqs = [
  {
    question: "Can I upgrade or downgrade my plan?",
    answer: "Yes, you can upgrade or downgrade your plan at any time.",
  },
  {
    question: "Is there a free trial available?",
    answer: "Yes, we offer a 14-day free trial for new users.",
  },
  {
    question: "Are there any cancellation fees?",
    answer: "No, there are no cancellation fees. You can cancel anytime.",
  },
  {
    question: "Can I pause my subscription instead of canceling it?",
    answer: "Yes, you can pause your subscription and resume it later.",
  },
  {
    question: "Do I need technical expertise to use Itump?",
    answer: "No, Itump is designed to be user-friendly for everyone.",
  },
];

export const footerLinks = [
  {
    section: "Company",
    links: [
      { title: "About", href: "/about" },
      { title: "Customer Stories", href: "/customer-stories" },
      { title: "News", href: "/news" },
      { title: "Pricing", href: "/pricing" },
      { title: "Team", href: "/team" },
      { title: "Help & Support", href: "/help-support" },
      { title: "Contact", href: "/contact" },
    ],
  },
  {
    section: "Solutions",
    links: [
      { title: "Pay", href: "/pay" },
      { title: "Wallet", href: "/wallet" },
      { title: "Health", href: "/health" },
      { title: "Corpcrypt", href: "/corpcrypt" },
      { title: "Asset", href: "/asset" },
      { title: "University", href: "/university" },
      { title: "Studio", href: "/studio" },
      { title: "Marketing", href: "/marketing" },
      { title: "Feedback", href: "/feedback" },
      { title: "Social", href: "/social" },
      { title: "CRM", href: "/crm" },
      { title: "Connect", href: "/connect" },
    ],
  },
  {
    section: "Services",
    links: [
      { title: "Register New Business", href: "/register-business" },
      { title: "Get a New EIN", href: "/get-ein" },
      { title: "FinCen's BOI", href: "/fincen-boi" },
      { title: "Build Business Credit", href: "/build-credit" },
      { title: "Change your Agent", href: "/change-agent" },
      { title: "Copyright & Trademark", href: "/copyright-trademark" },
      { title: "Annual Filing", href: "/annual-filing" },
      { title: "Close your Business", href: "/close-business" },
    ],
  },
];

export const socialLinks = [
  { imgSrc: "/svgs/socials/tiktok.svg", href: "https://tiktok.com/itump" },
  { imgSrc: "/svgs/socials/youtube.svg", href: "https://youtube.com/itump" },
  { imgSrc: "/svgs/socials/x.svg", href: "https://twitter.com/itump" },
  {
    imgSrc: "/svgs/socials/instagram.svg",
    href: "https://instagram.com/itump",
  },
  {
    imgSrc: "/svgs/socials/linkedin.svg",
    href: "https://linkedin.com/company/itump",
  },
];
